import React from "react";
import { RenderKilogramo } from "../../../../Utils/renderField/renderReadField";
import NullableValue from "../../../../Utils/renderField/nullableValue";

const getNombreAlmacen = (almacen) => {
    if (!almacen.padre_producto_terminado) {
        return almacen.nombre_almacen;
    }

    return `${almacen.nombre_almacen} - ${almacen.padre_producto_terminado}`;
};

export const ExistenciaAlmacenesTable = ({ almacenes = [], totales = {} }) => {
    if (!almacenes.length) {
        return (
            <div className="text-center py-5">
                <h3>No hay datos disponibles</h3>
            </div>
        );
    }

    return (
        <div className="new-table-wrapper my-4">
            <table className="table-striped-v2">
                <thead>
                    <tr>
                        <th>ID de almacén</th>
                        <th>Tipo de materia prima</th>
                        <th className="text-right">Kilos húmedos</th>
                        <th className="text-right">Kilos secos lab</th>
                        <th className="text-right">Kilos secos liq</th>
                        <th>Observaciones</th>
                    </tr>
                </thead>

                <tbody>
                    {almacenes.map((almacen) => (
                        <tr key={almacen.almacen_id}>
                            <td className="text-nowrap">
                                {getNombreAlmacen(almacen)}
                            </td>
                            <td>{almacen.materia_prima}</td>
                            <td className="text-right text-nowrap">
                                {/* 
                                    los cierres anteriores al guardado de kg húmedos no tienen el dato, se
                                    muestra un guion para no confundirlo con un almacén vacío 
                                */}
                                <NullableValue value={almacen.kg_humedos}>
                                    <RenderKilogramo
                                        value={almacen.kg_humedos}
                                        decimalScale={3}
                                    />
                                </NullableValue>
                            </td>
                            <td className="text-right text-nowrap">
                                <RenderKilogramo
                                    value={almacen.kg_secos_lab}
                                    decimalScale={3}
                                />
                            </td>
                            <td className="text-right text-nowrap">
                                <RenderKilogramo
                                    value={almacen.kg_secos_liq}
                                    decimalScale={3}
                                />
                            </td>
                            <td>{almacen.observaciones}</td>
                        </tr>
                    ))}

                    <tr className="totales-row">
                        <td className="fw-bold" colSpan={2}>
                            TOTAL
                        </td>
                        <td className="text-right fw-bold text-nowrap">
                            <NullableValue value={totales.kg_humedos}>
                                <RenderKilogramo
                                    value={totales.kg_humedos}
                                    decimalScale={3}
                                />
                            </NullableValue>
                        </td>
                        <td className="text-right fw-bold text-nowrap">
                            <RenderKilogramo
                                value={totales.kg_secos_lab}
                                decimalScale={3}
                            />
                        </td>
                        <td className="text-right fw-bold text-nowrap">
                            <RenderKilogramo
                                value={totales.kg_secos_liq}
                                decimalScale={3}
                            />
                        </td>
                        <td />
                    </tr>
                </tbody>
            </table>
        </div>
    );
};
